export default __webpack_public_path__ + "static/media/scb-logo.a04c764e.svg";